import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import KPIDashboard from "./KPIDashboard";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 1,
  overflow: "scroll",
};

export default function KPIDashboardModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Button
        sx={{
          bgcolor: "darkred.light",
          color: "white.main",
          textTransform: "none",
          fontWeight: "bold",
          mt: 1,
          "&:hover": {
             bgcolor: "darkred.main",
             color: "white.main",
          },
          marginLeft: "calc(100% -500px)",
       }}
        onClick={handleOpen}
      >
        View KPI Dashboard
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            //marginBottom: "12px",
            }}
              >
              <IconButton onClick={handleClose}>
              <CloseIcon />
              </IconButton>
              </Box>
          <Typography variant="subtitle1" sx={{ color: "darkred.light", mb: 2 ,mt:-1}}>
            KPI Dashboard
          </Typography>
          <KPIDashboard />
        </Box>
      </Modal>
    </Box>
  );
}
